import React, { Component } from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import imgBg from "../../../Assets/img/Group 2521.svg";
import imgMain from "../../../Assets/img/forgot_password.svg";
import { make_request, after_auth } from "../../Utils/Utils";
import queryString from "query-string";
import ReCAPTCHA from "react-google-recaptcha";

const reset_pwd_recaptcha_ref = React.createRef();

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      password: "",
      password_confirmation: "",
      validation_alert: false,
    };
  }

  resetCaptcha = () => {
    reset_pwd_recaptcha_ref.current.reset();
  };

  async componentDidMount() {
    let responseJson = queryString.parse(this.props.location.search);
    if (
      responseJson &&
      responseJson["access-token"] &&
      responseJson["access-token"] !== ""
    ) {
      let current_user_header = {
        "token-type": responseJson["token-type"],
        uid: responseJson["uid"],
        client: responseJson["client"],
        "access-token": responseJson["access-token"],
        expiry: responseJson["expiry"],
      };
      await localStorage.setItem(
        "current_user_header",
        JSON.stringify(current_user_header)
      );
    } else {
      this.props.history.push("/login");
    }
  }

  handle_change = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  submit_request = async () => {
    const recaptcha_response = await reset_pwd_recaptcha_ref.current.executeAsync();
    if (!!recaptcha_response) {
      this.setState({ validation_alert: false });
      let responseJson = await make_request({
        path: "auth/password",
        method: "PUT",
        body: {
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
          recaptcha_response: recaptcha_response,
        },
      });
      if (responseJson.status === "success") {
        this.setState({ validation_alert: false });
        after_auth(responseJson);
      } else {
        this.setState({ validation_alert: true });
      }
    }
  };

  render() {
    return (
      <div className="ForgotPassword innerBody">
        <Header />
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <img src={imgBg} alt="" className="pt-5" />
              <h3 className="title ml-auto mr-auto text-center mt-3 pt-2">
                RESET PASSWORD
              </h3>
              <div className="col-4 offset-4 text-center">
                <div className="row mt-5">
                  <input
                    name="password"
                    type="password"
                    className="form-control"
                    placeholder="Password *"
                    autocomplete="new-password"
                    value={this.state.password}
                    onChange={this.handle_change}
                  />
                </div>
                <div className="row mt-5">
                  <input
                    name="password_confirmation"
                    type="password"
                    className="form-control"
                    placeholder="Password Confirmation *"
                    value={this.state.password_confirmation}
                    onChange={this.handle_change}
                  />
                </div>

                <div className="wrong_txt mt-4 text-center">
                  {this.state.validation_alert && (
                    <p> Password does not Match </p>
                  )}
                </div>

                <div className="row mt-5">
                  <div className="col-4 offset-4 text-center">
                    <ReCAPTCHA
                      ref={reset_pwd_recaptcha_ref}
                      size="invisible"
                      sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                      onChange={this.resetCaptcha}
                    />
                    <button
                      disabled={this.state.submitted}
                      onClick={this.submit_request}
                      className="btn btn-yellow"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col text-center mt-5 mb-4">
              <img src={imgMain} alt="" />
              <img src={imgBg} alt="" className="img-main pt-1" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ResetPassword;
